import { render } from "./RecallClientCalendarDialog.vue?vue&type=template&id=3b0724da&scoped=true"
import script from "./RecallClientCalendarDialog.vue?vue&type=script&lang=js"
export * from "./RecallClientCalendarDialog.vue?vue&type=script&lang=js"

import "./RecallClientCalendarDialog.vue?vue&type=style&index=0&id=3b0724da&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b0724da"]])

export default __exports__